import styled from "styled-components";

export const Container = styled.div`
  padding: 28px 30px;
  max-height: calc(100vh - 60px);
  overflow: auto;
  .header {
    padding-bottom: 23px;
    button {
      border-radius: 6px;
      font-weight: 500;
      font-size: 14px;
      line-height: 150.5%;
      padding: 5px 10px;
      font-family: "Roboto";
      background: #ffffff;
      border: 1px solid #cdcfd0;
      color: #000;
      &.active {
        background: linear-gradient(90deg, #bc9b6a 9.9%, #947550 100%);
        box-shadow: 0px 10px 25px rgba(211, 190, 159, 0.5);
        color: #fff;
        border-color: transparent;
      }
    }
  }
`;
export const HeaderWrapper = styled.div`
  .checkbox-wrapper {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    padding: 4px 10px;
    margin-bottom: 10px;
    min-width: 210px;
    width: fit-content;
    .MuiFormControlLabel-label {
      font-size: 14px;
      white-space: normal;
    }
    .MuiButtonBase-root {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
`;

export const BodyWrapper = styled.div`
  .inner-menu {
    background: #ffffff;
    box-shadow: 0px 4px 5px rgb(0 0 0 / 5%);
    padding: 30px 40px;
  }
  .fulfillment-main-box {
    display: flex;
    gap: 15px 80px;
    .checkbox-label {
      margin-bottom: 10px;
      min-height: 21px;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 7px;
    }
    > div {
      max-width: 252px;
    }
    .checkbox-wrapper {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      padding: 4px 10px;
      margin-bottom: 10px;
      .MuiFormControlLabel-label {
        font-size: 14px;
        white-space: normal;
      }
      .MuiButtonBase-root {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }
`;

export const TopSection = styled.div`
  margin-bottom: 36px;
`;

export const MenuSection = styled.div`
  .filter-data {
    display: flex;
    padding-left: 25px;
    align-items: flex-start;
  }
`;
export const Filter = styled.div`
  border-bottom: 1px solid #0000000d;
  display: flex;
  margin: 30px 0 25px;
  gap: 20px;
  padding-left: 25px;
  justify-content: space-between;
  align-items: center;
  .MuiTab-root {
    padding-right: 0;
    padding-left: 0;
    margin: 0 20px;
    font-size: 14px;
    line-height: 150.5%;
    color: #000 !important;
    font-weight: normal;
    text-transform: initial;
  }
  .Mui-selected {
    font-weight: 500;
  }
  .MuiTabs-indicator {
    background-color: #bc9b6a;
  }
  .fulfillment-main-box {
    display: flex;
    gap: 15px 80px;

    > div {
      max-width: 252px;
    }
    .checkbox-wrapper {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      padding: 4px 10px;
      .MuiFormControlLabel-label {
        font-size: 14px;
      }
      .MuiButtonBase-root {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }
  .all-filter {
    display: flex;
    gap: 40px;
    align-items: center;
    button {
      font-weight: 400;
      font-size: 14px;
      line-height: 150.5%;
      background-color: transparent;
      border: none;
      padding: 10px 0;
      &.active {
        border-bottom: 2px solid #bc9b6a;
      }
    }
  }
`;
export const PromptAccept = styled.div`
  border: 1px dashed rgba(0, 0, 0, 0.6);
  max-width: 308px;
  flex: 1;
  position: sticky;
  top: 0;
  table {
    width: 100%;
    tr {
      th {
        font-weight: 500;
        font-size: 16px;
        line-height: 150.5%;
        padding: 14px 10px;
        border-bottom: 1px dashed rgba(0, 0, 0, 0.6);
      }

      .btn-wrapper {
        padding: 11px 0 24px;
      }
      .all-none-button {
        border: none;
        background-color: transparent;
        padding: 0;
      }
      .hole-btn {
        display: flex;
        gap: 7px;
        flex-direction: column;
        align-items: center;
        margin-bottom: 28px;
        button {
          width: 33px;
          height: 32px;
          font-weight: 500;
          font-size: 14px;
          line-height: 150.5%;
          background: #ffffff;
          border: 1px solid #c4c4c4;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          &.active {
            background: #bc9b6a;
            color: #ffffff;
          }
        }
      }
      td {
        text-align: center;
        :first-child {
          border-right: 1px dashed rgba(0, 0, 0, 0.6);
        }
      }
    }
  }
`;

export const ItemSection = styled.div`
  flex: 1;
  padding-left: 34px;
`;
export const HoursSection = styled.div`
    position: sticky;
    top: -29px;
    z-index: 1;
    background: #fff;
  .hour-selection-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    flex-wrap: wrap;
    padding: 18px 0;
    border-bottom: 1px solid #0000000d;
    .hour-selection-inner-wrapper {
      display: flex;
      align-items: center;
      gap: 15px 50px;
      flex-wrap: wrap;
    }  
  }
  .save-menu-parent {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin: 20px 0px;
    .save-changes-btn-wrapper {
        gap: 8px;
        display: flex;
        button {
          height: 43px;
          padding: 0 18px;
          border: 1px solid #636f7c;
          border-radius: 30px;
          font-weight: 500;
          font-size: 14px;
          line-height: 150.5%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #fff;
          color: inherit;
          text-transform: capitalize;
          font-weight: 400;
        }
      }
    }
  .hour-select {
    display: flex;
    align-items: center;
    gap: 24px;
    .MuiSelect-select {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      padding: 2.5px 14px;
      font-size: 13px;
    }
    .MuiFormControl-root {
      margin: 0;
    }
    .MuiSelect-icon {
      width: 17px;
    }
  }
  .total-hours {
    display: flex;
    gap: 22px;
    align-items: center;
    span {
      font-weight: 500;
      font-size: 14px;
      line-height: 150.5%;
    }
  }
  .heading {
    font-weight: 500;
    font-size: 16px;
    line-height: 150.5%;
  }
`;

export const GroupItemSection = styled.div`
  .group-item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    padding: 20px 0 17px;
    .add-group-btn-wrapper {
      gap: 8px;
      display: flex;
      align-items: center;
      button {
        height: 43px;
        border: 1px solid #636f7c;
        border-radius: 30px;
        font-weight: 500;
        font-size: 14px;
        line-height: 150.5%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        gap: 10px;
        padding: 0 17px;
        text-transform: capitalize;
        color: inherit;
        font-weight: 400;
      }
    }
    .collapse-expand-btn-wrapper {
      gap: 8px;
      display: flex;
      align-items: center;
      button {
        background-color: transparent;
        border: none;
        padding: 0;
        font-size: 14px;
        line-height: 150.5%;
      }
    }
  }
`;

export const FoodItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  .MuiAccordion-root {
    border: 1px solid #e7e7e7;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  }
  .MuiAccordionDetails-root {
    padding: 0;
  }
`;

export const ItemsWrapper = styled.div`
  background: #fcfcfc;
  border-top: 1px solid #e7e7e7;
  padding: 45px 39px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  .MuiAccordionSummary-root {
    padding-left: 0;
    .inner-item-row {
      border: none;
      padding: 0 10px;
    }
  }
  .MuiAccordionDetails-root {
    padding: 10px 10px 10px 20px;
    .inner-item-row {
      margin-bottom: 7px;
    }
  }
`;

export const ItemRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding-left: 20px;
  /* &.add-item-header {
  } */
  &.inner-item-row {
    border: 1px dashed rgba(0, 0, 0, 0.6);
    padding: 10px;
  }
  &.outer-item-row {
    background: #ffffff;
    border: 1px solid #e7e7e7;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
    padding: 11px 42px 11px 36px;
  }
  .price-input {
    display: flex;
    align-items: center;
    gap: 8px;
    span {
      font-size: 14px;
      line-height: 150.5%;
    }
    input {
      width: 100%;
      max-width: 117px;
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      height: 40px;
      min-width: 50px;
      padding: 0 5px;
    }
  }
  .input-section {
    display: flex;
    align-items: center;
    gap: 20px;
    flex: 0.7;
    .food-img-wrapper {
      min-width: 63px;
      max-width: 63px;
      height: 60px;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;
      img {
        width: 100%;
        object-fit: scale-down;
        max-width: 100%;
      }
    }
    input {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      width: 100%;
      max-width: 411px;
      height: 40px;
      pointer-events: auto;
      padding: 0 5px;
      min-width: 200px;
    }
  }
  .action-wrapper {
    display: flex;
    align-items: center;
    gap: 30px;
    padding-right: 25px;
    pointer-events: auto;
    .add-btn {
      background: #ffffff;
      border: 1px solid #636f7c;
      border-radius: 30px;
      font-size: 13px;
      line-height: 150.5%;
      gap: 5px;
      display: flex;
      align-items: center;
      height: 30px;
      padding: 0 16px;
    }
  }
`;

export const AddImageContainer = styled.div`
  max-height: 410px;
  .header {
    background: #6b5c4b;
    border-radius: 5px 5px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    min-height: 40px;
    .action-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
    }
    h4 {
      font-weight: 700;
      font-size: 14px;
      line-height: 150.5%;
      color: #ffffff;
    }
    button {
      background: #bc9b6a;
      border: 1px solid #bc9b6a;
      border-radius: 6px;
      color: #ffffff;
      font-size: 14px;
      line-height: 150.5%;
      padding: 2.5px 10px;
    }
  }
  .images-container {
    padding: 18px 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 18px;
    overflow: scroll;
    height: 370px;
    > div {
      width: 80px;
      height: 76px;
      border: 1px solid #6b5c4b;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;
    }
  }
`;
